module.exports = __webpack_public_path__ + "assets/images/img/Level_padel.22dbb5ce4e388a4d3b8ca6f9f7d727ff.png";